import { Link } from "react-router-dom";
import { getRestaurants } from "@/lib/store";

export default function SiteFooter() {
  function csvEscape(v: any): string {
    const s = v == null ? '' : String(v);
    if (/[",\n\r]/.test(s)) return '"' + s.replace(/"/g, '""') + '"';
    return s;
  }
  function exportCsv() {
    try {
      const restaurants = getRestaurants();
      const fields = [
        'id','name','cuisine','location','prefecture','municipality','isWishlist','rating','ratingTaste','ratingTasteBalance','ratingTasteIngredients','ratingTasteTechnique','ratingTasteFine','ratingTasteGrade','ratingAmbience','ratingService','ratingCost','visitDate','visitHistory','priceRange','sourceUrl','tiktokUrl','createdAt','updatedAt','wishlistBy','notes'
      ] as const;
      const rows = restaurants.map((r) => {
        const obj: Record<string, any> = { ...r } as any;
        const vh = Array.isArray((obj as any).visitHistory) ? (obj as any).visitHistory.join('|') : '';
        const wb = Array.isArray((obj as any).wishlistBy) ? (obj as any).wishlistBy.join('|') : '';
        return (fields as unknown as string[])
          .map((f) => csvEscape(f === 'visitHistory' ? vh : f === 'wishlistBy' ? wb : (obj as any)[f] ?? ''))
          .join(',');
      });
      const header = (fields as unknown as string[]).join(',');
      const csv = [header, ...rows].join('\r\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      const ts = new Date().toISOString().replace(/[:.]/g,'-');
      a.href = url;
      a.download = `ccq-export-${ts}.csv`;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => { URL.revokeObjectURL(url); a.remove(); }, 0);
    } catch { /* noop */ }
  }
  return (
    <footer className="border-t mt-6">
      <div className="container mx-auto max-w-5xl px-3 sm:px-4 py-4 text-xs text-muted-foreground flex items-center justify-between">
        <span>© Futari no Tabelog</span>
        <div className="flex items-center gap-4">
          <button onClick={exportCsv} className="underline" title="CSVで全件エクスポート">エクスポート</button>
          <Link to="/" className="underline">トップへ戻る</Link>
        </div>
      </div>
    </footer>
  );
}
